import {
  MATIC_BUILDER_KIT_PRODUCT_ID,
  MATIC_BUILDER_KIT_VARIANT_ID,
} from "@/consts/shopify";

export const isBuilderKitProductId = (productId?: string | null) => {
  return productId === MATIC_BUILDER_KIT_PRODUCT_ID;
};

export const isBuilderKitVariantId = (variantId?: string | null) => {
  return variantId === MATIC_BUILDER_KIT_VARIANT_ID;
};
